import React from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  useLocation
} from "react-router-dom";
import { AuthProvider, useAuth } from './context/auth';
import {
  ViewLogin,
  ViewDashboard,
  ViewPatients,
  ViewPrescriptions,
  ViewMdIntegrations,
  ViewHallandale,
  ViewPatientProfile,
  ViewUsers,
  ViewProspects,
  ViewReports,
  ViewSettings
} from './views';

const ClientRoutes = () => {

  const ProtectedRoute = ({children}:any) => {
    const { user } = useAuth();
    const location = useLocation();

    if (!user) {
      return <Navigate to="/" replace state={{ from: location }} />;
    }
  
    return children;
  };


  const router = createBrowserRouter([
    {
      path: "/",
      element: <ViewLogin />
    },
    {
      path: "/patients",
      element:
        <ViewDashboard>
          <ProtectedRoute>
            <ViewPatients />
          </ProtectedRoute>
        </ViewDashboard>,
    },
    {
      path: "/prescriptions",
      element:
        <ViewDashboard>
          <ProtectedRoute>
            <ViewPrescriptions />
          </ProtectedRoute>
        </ViewDashboard>,
    },
    {
      path: "/md-integrations",
      element:
        <ViewDashboard>
          <ProtectedRoute>
            <ViewMdIntegrations />
          </ProtectedRoute>
        </ViewDashboard>,
    },
    {
      path: "/hallandale",
      element:
        <ViewDashboard>
          <ProtectedRoute>
            <ViewHallandale />
          </ProtectedRoute>
        </ViewDashboard>,
    },
    {
      path: "/prospects",
      element:
        <ViewDashboard>
          <ProtectedRoute>
            <ViewProspects />
          </ProtectedRoute>
        </ViewDashboard>,
    },
    {
      path: "/reports",
      element:
        <ViewDashboard>
          <ProtectedRoute>
            <ViewReports />
          </ProtectedRoute>
        </ViewDashboard>,
    },
    {
      path: "/users",
      element:
        <ViewDashboard>
          <ProtectedRoute>
            <ViewUsers />
          </ProtectedRoute>
        </ViewDashboard>,
    },
    {
      path: "/profile/:id",
      element:
        <ViewDashboard>
          <ProtectedRoute>
            <ViewPatientProfile />
          </ProtectedRoute>
        </ViewDashboard>,
    },
    {
      path: "/settings/change-password",
      element:
        <ViewDashboard>
          <ProtectedRoute>
            <ViewSettings />
          </ProtectedRoute>
        </ViewDashboard>,
    },
  ]);

  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
};

export default ClientRoutes;
